module.exports = __webpack_public_path__ + "static/media/20-beal-wave_10_10_2020.17b1abba.jpeg";